import { Injectable } from '@angular/core';
import { CloudService, InstanceService } from '@serengeti/serengeti-resource';
import { ThemeService } from 'src/app/setting/theme/service/theme.service';

export class colorHelper {
  static shade = (color, weight) => {
    return colorHelper.mix('#000000', color, weight);
  };

  static tint = (color, weight) => {
    return colorHelper.mix('#ffffff', color, weight);
  };

  static hexToRgbA = (hex, alpha) => {
    let c;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length == 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = '0x' + c.join('');
      return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + alpha + ')';
    }
    throw new Error('Bad Hex');
  };

  static mix = (color1, color2, weight) => {

    let d2h = (d) => d.toString(16);
    let h2d = (h) => parseInt(h, 16);

    let result = "#";
    for (let i = 1; i < 7; i += 2) {
      let color1Part = h2d(color1.substr(i, 2));
      let color2Part = h2d(color2.substr(i, 2));
      let resultPart = d2h(Math.floor(color2Part + (color1Part - color2Part) * (weight / 100.0)));
      result += ('0' + resultPart).slice(-2);
    }
    return result;
  };
}

export class Cloud {
  value: number;
  color: string;
  highlight: string;
  label: string;
  percentage: number;
  order: number;
  total: number;

	public constructor(value: number, color: string, highlight: string, label: string, percentage: number, order: number  ) {
    this.value = value;
    this.color = color;
    this.highlight = highlight;
    this.label = label;
    this.percentage = percentage;
    this.order = order;
	}
}

@Injectable({
  providedIn: 'root'
})
export class WizardResourceCloudService {

  private data: any;

  constructor(
    private instanceService: InstanceService,
    private cloudService: CloudService,
    private themeService: ThemeService
    ) { }

  async getData() {
    this.data = {
      'total' : Number,
      'cloud' : []
    }

    const instance = await this.instanceService.list().toPromise();
    let cloud = await this.cloudService.vendors().toPromise();

    cloud.forEach(function(cloud, index) {
          let count = 0;
          instance.forEach(function(instance, index) {
            //if(instance.nativeState != 'terminated') {
              const vendor = instance.pool.region.cloud.vendor;
              if (cloud.vendor == vendor) {
                count++;
              }
            //}
          });
          cloud.count = count;
    });

    this.data.total = cloud.reduce((a, b) => +a + +b.count, 0);

    cloud = cloud.sort(function(a, b) { return (b.count) - (a.count); }).slice(0, 5);

    const themeColors = this.themeService.getThemeColors();
    const dashboardColors = themeColors.chartSeriesColors;
    const colors = Object.keys(dashboardColors);

    cloud.forEach(function(cloud: any, index: number) {
        const color =  dashboardColors[colors[index]];
        const highlight = colorHelper.shade( dashboardColors[colors[index]], 15);
        const percentage = +((cloud.count / this.data.total) * 100).toFixed(1);
        const order = index + 1;
        this.data.cloud.push(new Cloud(cloud.count, color, highlight, cloud.name, percentage, order));
    }.bind(this));

    return JSON.parse(JSON.stringify(this.data));
  }

}
